<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Add Store Product
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="3">
              <v-autocomplete
                ref="products"
                outlined
                v-model="form.product_id"
                :items="productItems"
                label="Product"
                multiple
                prepend-inner-icon="mdi-arrow-expand-all"
                clearable
                :error-messages="errors.product_id"
              ></v-autocomplete>
            </v-col>
            <v-col>
              <input
                type="checkbox"
                @change="selectAllProducts"
                v-model="is_select_all"
              />
              Select All Products
            </v-col>
            <!-- <v-col sm="4">
              <v-text-field
                v-model="form.alloted_quantity"
                outlined
                label="Allotted Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.alloted_quantity"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.current_quantity"
                outlined
                label="Current Quantity"
                prepend-inner-icon="mdi-card-text-outline"
                :error-messages="errors.current_quantity"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Map Product
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "StoreProductCreatePage",
  data() {
    return {
      form: {
        store_id: "",
        quantity: 0,
        product_id: "",
      },
      storeItems: [],
      productItems: [],
      isLoading: false,
      is_select_all: false,
    };
  },
  mounted() {
    this.form.store_id = this.decryptIt(this.$route.params.storeId);
    console.log(this.form);

    this.getData();
    this.getMasters();
  },
  watch: {
    form: {
      deep: true,
      handler(newForm) {
        if (newForm.product_id.length === 0) {
          this.is_select_all = false; // Uncheck when all selections are cleared
        }
      },
    },
  },
  methods: {
    getData() {
      let query = "store_id=" + this.form.store_id;
      console.log(query);

      axios
        .get(`/store_products?${query}`) // Query string ko proper format mein bhejna
        .then((response) => {
          this.store_products = response.data.data;
          console.log("storeGift", this.store_products);
          this.getMasters(); // getData ke baad getMasters call karein taaki data sync rahe
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getMasters() {
      await axios
        .get(`store_products/masters`)
        .then((masters) => {
          masters = masters.data;
          //gift masters

          if (this.store_products.length == 0) {
            console.log("this.store_products", "null");
            // Agar store gifts empty hai, toh saare gifts dikhao
            this.productItems = masters.products.map((product) => ({
              id: product.id,
              text: product.name,
              value: product.id,
            }));
          } else {
            console.log("this.store_products", this.store_products);
            // Store Gifts IDs ko extract karna hai
            const storeProductIds = this.store_products.map(
              (product) => product.product_id
            );
            console.log("storeProductIds", storeProductIds);

            // Filter products jo store products mein nahi hain
            this.productItems = masters.products
              .filter((product) => !storeProductIds.includes(product.id))
              .map((product) => ({
                id: product.id,
                text: product.name,
                value: product.id,
              }));
          }
        })
        .catch(function (error) {
          console.log(error);
          // redirect to Home Page
          // window.location.href = "/auth/login";
        });
    },
    selectAllProducts() {
      if (this.is_select_all) {
        this.form.product_id = this.productItems.map(
          (product) => product.value
        ); // Select all gifts
      } else {
        this.form.product_id = []; // Clear selection
      }
    },
    async save() {
      try {
        this.isLoading = true;
        this.form.current_quantity = this.form.alloted_quantity;
        await axios.post("/store_products", this.form);
        await this.saveUserTimestamp(null, this.form);
        this.isLoading = false;
        this.$router.push(
          `/stores/${this.$route.params.storeId}/store-products`
        );
      } catch (e) {
        // alert("error");
        console.log(e);
        this.isLoading = false;
      }
    },
  },
};
</script>
